var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndianSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13552_13724)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 0H28V8.25H-5V0Z",
    fill: "#FF8000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 8.25H28V16.5H-5V8.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 16.5H28V24.75H-5V16.5Z",
    fill: "#128807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5002 15.6781C13.3227 15.6781 14.8002 14.2007 14.8002 12.3781C14.8002 10.5556 13.3227 9.07812 11.5002 9.07812C9.67766 9.07812 8.2002 10.5556 8.2002 12.3781C8.2002 14.2007 9.67766 15.6781 11.5002 15.6781Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5003 15.2652C13.095 15.2652 14.3878 13.9725 14.3878 12.3777C14.3878 10.783 13.095 9.49023 11.5003 9.49023C9.90557 9.49023 8.61279 10.783 8.61279 12.3777C8.61279 13.9725 9.90557 15.2652 11.5003 15.2652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5004 12.9558C11.8193 12.9558 12.0779 12.6972 12.0779 12.3783C12.0779 12.0593 11.8193 11.8008 11.5004 11.8008C11.1814 11.8008 10.9229 12.0593 10.9229 12.3783C10.9229 12.6972 11.1814 12.9558 11.5004 12.9558Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3438 12.9017C14.4251 12.9124 14.4997 12.8552 14.5104 12.7739C14.5211 12.6926 14.4639 12.618 14.3826 12.6073C14.3013 12.5966 14.2267 12.6538 14.216 12.7351C14.2053 12.8164 14.2625 12.891 14.3438 12.9017Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5004 15.2645L11.5994 13.532L11.5004 12.707L11.4014 13.532L11.5004 15.2645Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1105 13.6222C14.1862 13.6536 14.2731 13.6176 14.3045 13.5419C14.3359 13.4661 14.2999 13.3792 14.2241 13.3478C14.1483 13.3165 14.0615 13.3524 14.0301 13.4282C13.9987 13.504 14.0347 13.5909 14.1105 13.6222Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7525 15.1679L11.2966 13.52L11.4145 12.6975L11.1053 13.4688L10.7525 15.1679Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7007 14.2538C13.7657 14.3037 13.859 14.2914 13.9089 14.2263C13.9588 14.1613 13.9466 14.0681 13.8815 14.0181C13.8164 13.9682 13.7232 13.9805 13.6733 14.0455C13.6233 14.1106 13.6356 14.2038 13.7007 14.2538Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.057 14.8796L11.009 13.4287L11.3357 12.6647L10.8375 13.3297L10.057 14.8796Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1409 14.7576C13.1908 14.8227 13.2841 14.8349 13.3491 14.785C13.4142 14.7351 13.4265 14.6419 13.3765 14.5768C13.3266 14.5117 13.2334 14.4995 13.1683 14.5494C13.1033 14.5993 13.091 14.6925 13.1409 14.7576Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45933 14.4175L10.7544 13.2624L11.2678 12.6091L10.6144 13.1224L9.45933 14.4175Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.468 15.1063C12.4994 15.1821 12.5862 15.2181 12.662 15.1867C12.7378 15.1553 12.7738 15.0684 12.7424 14.9927C12.711 14.9169 12.6241 14.8809 12.5484 14.9123C12.4726 14.9437 12.4366 15.0306 12.468 15.1063Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00017 13.8235L10.5501 13.043L11.215 12.5447L10.4511 12.8715L9.00017 13.8235Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7303 15.2622C11.741 15.3435 11.8156 15.4007 11.8969 15.39C11.9782 15.3793 12.0355 15.3047 12.0248 15.2234C12.014 15.1421 11.9395 15.0848 11.8581 15.0956C11.7768 15.1063 11.7196 15.1809 11.7303 15.2622Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71298 13.1267L10.4121 12.7739L11.1833 12.4648L10.3608 12.5827L8.71298 13.1267Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9762 15.2217C10.9655 15.3031 11.0227 15.3777 11.104 15.3884C11.1854 15.3991 11.26 15.3418 11.2707 15.2605C11.2814 15.1792 11.2241 15.1046 11.1428 15.0939C11.0615 15.0832 10.9869 15.1404 10.9762 15.2217Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61389 12.3783L10.3464 12.4773L11.1714 12.3783L10.3464 12.2793L8.61389 12.3783Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2581 14.9884C10.2267 15.0642 10.2627 15.151 10.3385 15.1824C10.4143 15.2138 10.5011 15.1778 10.5325 15.102C10.5639 15.0263 10.5279 14.9394 10.4522 14.908C10.3764 14.8766 10.2895 14.9126 10.2581 14.9884Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71252 11.631L10.3604 12.175L11.1829 12.2929L10.4116 11.9837L8.71252 11.631Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62417 14.5854C9.57424 14.6505 9.58651 14.7437 9.65158 14.7937C9.71665 14.8436 9.80987 14.8313 9.85979 14.7663C9.90972 14.7012 9.89745 14.608 9.83238 14.558C9.76732 14.5081 9.6741 14.5204 9.62417 14.5854Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00029 10.9418L10.4512 11.8937L11.2151 12.2205L10.5502 11.7223L9.00029 10.9418Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11887 14.0208C9.0538 14.0707 9.04153 14.1639 9.09145 14.229C9.14138 14.2941 9.2346 14.3063 9.29967 14.2564C9.36473 14.2065 9.37701 14.1133 9.32708 14.0482C9.27715 13.9831 9.18393 13.9709 9.11887 14.0208Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45897 10.3397L10.614 11.6348L11.2674 12.1481L10.754 11.4948L9.45897 10.3397Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77405 13.3527C8.69828 13.3841 8.6623 13.471 8.69368 13.5468C8.72507 13.6225 8.81193 13.6585 8.88771 13.6271C8.96348 13.5958 8.99946 13.5089 8.96807 13.4331C8.93669 13.3573 8.84982 13.3214 8.77405 13.3527Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0559 9.88347L10.8364 11.4334L11.3347 12.0983L11.0079 11.3344L10.0559 9.88347Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61772 12.6116C8.5364 12.6223 8.47916 12.6969 8.48987 12.7783C8.50057 12.8596 8.57517 12.9168 8.65648 12.9061C8.73779 12.8954 8.79503 12.8208 8.78433 12.7395C8.77362 12.6582 8.69903 12.6009 8.61772 12.6116Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7527 9.59238L11.1055 11.2915L11.4146 12.0627L11.2967 11.2402L10.7527 9.59238Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65667 11.858C8.57536 11.8473 8.50077 11.9046 8.49006 11.9859C8.47936 12.0672 8.53659 12.1418 8.61791 12.1525C8.69922 12.1632 8.77381 12.106 8.78452 12.0246C8.79522 11.9433 8.73799 11.8687 8.65667 11.858Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5001 9.49523L11.4011 11.2277L11.5001 12.0527L11.5991 11.2277L11.5001 9.49523Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88955 11.1414C8.81378 11.1101 8.72691 11.146 8.69552 11.2218C8.66414 11.2976 8.70012 11.3844 8.77589 11.4158C8.85166 11.4472 8.93853 11.4112 8.96991 11.3355C9.0013 11.2597 8.96532 11.1728 8.88955 11.1414Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2475 9.59777L11.7034 11.2456L11.5855 12.0681L11.8947 11.2969L12.2475 9.59777Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29932 10.506C9.23425 10.4561 9.14103 10.4683 9.0911 10.5334C9.04118 10.5985 9.05345 10.6917 9.11852 10.7416C9.18358 10.7916 9.2768 10.7793 9.32673 10.7142C9.37666 10.6492 9.36438 10.5559 9.29932 10.506Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.943 9.88017L11.991 11.3311L11.6643 12.095L12.1625 11.4301L12.943 9.88017Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85958 10.0022C9.80965 9.9371 9.71643 9.92483 9.65137 9.97475C9.5863 10.0247 9.57403 10.1179 9.62395 10.183C9.67388 10.248 9.7671 10.2603 9.83217 10.2104C9.89723 10.1605 9.90951 10.0672 9.85958 10.0022Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5412 10.3423L12.2461 11.4973L11.7327 12.1507L12.3861 11.6373L13.5412 10.3423Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.533 9.65149C10.5016 9.57572 10.4147 9.53974 10.339 9.57112C10.2632 9.60251 10.2272 9.68938 10.2586 9.76515C10.29 9.84092 10.3769 9.8769 10.4526 9.84552C10.5284 9.81413 10.5644 9.72726 10.533 9.65149Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0008 10.9343L12.4509 11.7149L11.7859 12.2131L12.5499 11.8863L14.0008 10.9343Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2712 9.49369C11.2605 9.41238 11.1859 9.35514 11.1046 9.36585C11.0232 9.37655 10.966 9.45115 10.9767 9.53246C10.9874 9.61377 11.062 9.67101 11.1433 9.6603C11.2246 9.6496 11.2819 9.575 11.2712 9.49369Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2885 11.6292L12.5894 11.9819L11.8181 12.2911L12.6406 12.1732L14.2885 11.6292Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0238 9.53216C12.0345 9.45085 11.9773 9.37625 11.896 9.36555C11.8146 9.35484 11.74 9.41208 11.7293 9.4934C11.7186 9.57471 11.7759 9.6493 11.8572 9.66001C11.9385 9.67071 12.0131 9.61347 12.0238 9.53216Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3861 12.3756L12.6536 12.2766L11.8286 12.3756L12.6536 12.4746L14.3861 12.3756Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7419 9.76943C12.7733 9.69366 12.7373 9.60679 12.6615 9.57541C12.5857 9.54402 12.4989 9.58 12.4675 9.65577C12.4361 9.73154 12.4721 9.81841 12.5478 9.8498C12.6236 9.88118 12.7105 9.8452 12.7419 9.76943Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2875 13.1268L12.6396 12.5828L11.8171 12.4649L12.5884 12.7741L14.2875 13.1268Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3773 10.1763C13.4272 10.1112 13.415 10.018 13.3499 9.96806C13.2848 9.91813 13.1916 9.9304 13.1417 9.99547C13.0917 10.0605 13.104 10.1538 13.1691 10.2037C13.2341 10.2536 13.3274 10.2413 13.3773 10.1763Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0012 13.82L12.5503 12.868L11.7863 12.5412L12.4513 13.0395L14.0012 13.82Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8826 10.739C13.9477 10.689 13.9599 10.5958 13.91 10.5308C13.8601 10.4657 13.7669 10.4534 13.7018 10.5033C13.6367 10.5533 13.6245 10.6465 13.6744 10.7116C13.7243 10.7766 13.8175 10.7889 13.8826 10.739Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5425 14.4201L12.3874 13.125L11.7341 12.6116L12.2474 13.265L13.5425 14.4201Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2264 11.4051C14.3022 11.3737 14.3382 11.2868 14.3068 11.211C14.2754 11.1353 14.1886 11.0993 14.1128 11.1307C14.037 11.1621 14.001 11.2489 14.0324 11.3247C14.0638 11.4005 14.1507 11.4364 14.2264 11.4051Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9446 14.8743L12.1641 13.3245L11.6658 12.6595L11.9926 13.4235L12.9446 14.8743Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3823 12.1442C14.4636 12.1335 14.5208 12.0589 14.5101 11.9776C14.4994 11.8963 14.4248 11.8391 14.3435 11.8498C14.2622 11.8605 14.205 11.9351 14.2157 12.0164C14.2264 12.0977 14.301 12.1549 14.3823 12.1442Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2473 15.1635L11.8945 13.4644L11.5854 12.6931L11.7033 13.5156L12.2473 15.1635Z",
    fill: "#000088"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13552_13724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndianSvg);
export default __webpack_public_path__ + "static/media/IndianSvg.cbc425f7c62abdbe7b38dbe497789cd3.svg";
export { ForwardRef as ReactComponent };